export class MediaVideoGrouper {

    // staff
    liveId;
    videoPlaylist = $('.md-video-playlist');

    constructor() {
        this.init();
    }

    init() {
        if (this.videoPlaylist.length) {
            this.startPlaylist();
        }
    }

    startPlaylist() {
        this.videoPlaylist.each((key, liveList) => {
            const liveModule = $(liveList);

            // Main video
            const mainPlayer = liveModule.find('.video-js');
            if (!mainPlayer.length) {
                return;
            }

            if (!liveModule.find('.video-js')[0]) {
                return;
            }

            this.liveId = liveModule.find('.video-js')[0].id;
            if (!this.liveId) {
                return;
            }

            liveModule.on('click','.live-container-blur', () => {
                videojs.getPlayer(this.liveId).ready(function () {
                    let myPlayer = this;
                    myPlayer.play();
                });
            });

            videojs.getPlayer(this.liveId).on('play', () => {
                this.hideVideoStyles(liveModule);
            });

            // Click playlist videos
            const playlist = liveModule.find('.card-news--video-item');
            playlist.each((key, item) => {
                const videoItem = $(item);

                videoItem.click((e) => {
                    e.preventDefault();

                    const videoId = videoItem.data('videoEmbedcode');
                    const accountId = videoItem.data('videoAccount');
                    const playerId = videoItem.data('videoDataplayer');
                    const liveContainer = videoItem.closest('.md-video-playlist').find('.live-container');
                    if (videoId && accountId && playerId && liveContainer) {
                        // Change video from list
                        this.setVideo(videoId, accountId, playerId, liveContainer);
                        this.hideVideoStyles(liveModule);
                    }
                })
            })
        });
    }

    // Build the player and place in HTML DOM
    setVideo(videoId, accountId, playerId, liveContainer) {
        const liveScript = $('.live-script');

        // Delete the old script and video
        liveScript.remove();
        // Silence the video, there is a bug with the autoplay
        liveContainer.find('video')[0].muted = true;
        liveContainer.find('.media-video').remove();

        // Dynamically build the player video element
        const playerHTML =
            '<figure class="media-video">' +
                '<video-js id="' + this.liveId + '"' +
                    ' data-video-id="' + videoId +
                    '" data-account="' + accountId +
                    '" data-player="' + playerId +
                    '" data-embed="default" class="video-js" controls></video-js>' +
            '</figure>';

        // Inject the player code into the DOM
        liveContainer.html(playerHTML);
        // Add and execute the player script tag
        const s = document.createElement("script");
        s.className = "live-script";
        s.src = "https://players.brightcove.net/" + accountId + "/" + playerId + "_default/index.min.js";
        // Add the script tag to the document
        document.body.appendChild(s);
        // Call a function to play the video once player's JavaScript loaded
        s.onload = () => {
            this.callbackStartVideo(this.liveId)
        };
    }

    // Initialize the player and start the video
    callbackStartVideo(liveId) {
        const myPlayer = bc(liveId);
        // Can also use the following to assign a player instance to the variable if you choose not to use IDs for elements directly
        // myPlayer = bc(document.getElementById('myPlayerID'));
        myPlayer.on("loadedmetadata", () => {
            myPlayer.play();
        });
    }

    // Hide .card-news__body and remove .live-container-blur
    hideVideoStyles(liveModule) {
        liveModule.find('.card-news--live').find('.card-news__body').hide();
        liveModule.find('.card-news--live').find('.live-container').removeClass("live-container-blur");
    }
}
